import { Component, inject } from '@angular/core';
import { AyudaService } from '../services/ayuda.service';
import { MarkdownPipe } from "../../shared/pipes/markdown-pipe";
import { AsyncPipe } from '@angular/common';

@Component({
  selector: 'app-ayuda',
  imports: [MarkdownPipe, AsyncPipe],
  templateUrl: './ayuda.html',
  styleUrl: './ayuda.scss',
})
export class Ayuda {
  readonly ayudaService = inject(AyudaService);
  readonly ayudaData$ = this.ayudaService.getAyuda();

}
